// Partner Routing & Packing — shared constants.
// Mirrors the contract documented in
// citymall-services/docs/cp-features/partner-web/{cp-routing.md,crate-cx-items.md}.

export const MODES = {
  ROUTING: "ROUTING",
  CRATE_CX_ITEMS: "CRATE_CX_ITEMS",
};

// CP Routing sub-tabs — display label vs. internal data key.
export const ROUTING_SUB_TABS = [
  { key: "DC", label: "Locality" },
  { key: "CRATE", label: "Crate" },
  { key: "TP", label: "Customer" },
];

export const ROUTING_MAIN_TYPE = "TODAY"; // page only uses TODAY today.

export const SORT_KEYS = {
  TP: "TP",
  LARGE_CRATES: "LARGE_CRATES",
  SMALL_CRATES: "SMALL_CRATES",
};

// Crate Cx Items tabs — passed as ?tab= to /search-crate-v2 and /get-crate-cx-items.
export const CRATE_TABS = [
  { key: "today", label: "Today" },
  { key: "rescheduled", label: "Rescheduled" },
];

// Crate type → human label & color for the search-result tag.
export const CRATE_TYPE_TAG = {
  TODAY: { label: "Today", color: "blue" },
  YESTERDAY: { label: "D-1", color: "green" },
  DAY_BEFORE_YESTERDAY: { label: "D-2", color: "orange" },
  RESCHEDULED: { label: "Rescheduled", color: "purple" },
  RESCHEDULED_YESTERDAY: { label: "Rescheduled D-1", color: "cyan" },
  RESCHEDULED_DAY_BEFORE_YESTERDAY: {
    label: "Rescheduled D-2",
    color: "magenta",
  },
};

// Per-reason palette tokens (bg / fg / border) — keyed by the reason's
// semantic colour name. Mirrors the antd Tag colors used on the web.
export const REASON_PALETTES = {
  red: { bg: "#FFF1F0", fg: "#A8071A", border: "#FFA39E" },
  orange: { bg: "#FFF2E8", fg: "#D46B08", border: "#FFBB96" },
  gold: { bg: "#FFFBE6", fg: "#AD8B00", border: "#FFE58F" },
  purple: { bg: "#F9F0FF", fg: "#531DAB", border: "#D3ADF7" },
  blue: { bg: "#E6F7FF", fg: "#0050B3", border: "#91D5FF" },
  default: { bg: "#FAFAFA", fg: "#595959", border: "#D9D9D9" },
};

// Issue reasons accepted by /cp-pack-cx-item-v3. The marking sheet only
// edits item_damaged / wrong_item_received / not_found; the rest are
// receive-only labels for already-marked rows.
export const ISSUE_REASONS = {
  item_damaged: { label: "Item Damaged", color: "red", alwaysShown: true },
  wrong_item_received: {
    label: "Wrong Item Received",
    color: "orange",
    hideForCdc: true,
    hideForTopSku: true,
  },
  not_found: { label: "Item Not Found", color: "red", hideForCdc: true },
  partial_not_found: { label: "Partial Item Not Found", color: "gold" },
  ofd_db_lost_damage: { label: "OFD DB Lost/Damage", color: "purple" },
  cx_rto_predelivery: { label: "Customer RTO (Pre-delivery)", color: "blue" },
  found: { label: "Customer RTO", color: "default" },
};

// Server returns this as the bucket key for image URLs in the marking payload.
export const ISSUE_IMAGE_BUCKETS = [
  "item_damaged",
  "wrong_item_received",
  "partial_not_found",
];

// Per cp-routing.vue — backend shipped a placeholder URL that satisfies
// upstream image-URL validation. DC routing packing must use the same dummy URL until
// real image-upload lands on the backend.
export const DUMMY_ISSUE_IMAGE_URL =
  "https://cm-admin-storage.citymall.live/store-info%2F1759836820031-rvp_sample_dummy.png";

// Default map center used by the web "View Map" modal (Gurugram).
export const DEFAULT_MAP_CENTER = { lat: 28.4595, lng: 77.0266 };

// Round-robin marker palette — keyed by crate index so all markers from one
// crate share a color across the map.
export const MAP_MARKER_COLORS = [
  "red",
  "blue",
  "green",
  "purple",
  "orange",
  "yellow",
  "pink",
  "cyan",
];

// Datum keys used for the soft-permission check.
export const DATUM_PAGE = {
  ROUTING: "cp-routing",
  CRATE_CX_ITEMS: "crate-cx-items",
};

// Default search-debounce (ms). Web uses 500; dc-routing-packing feels snappier at 400.
export const SEARCH_DEBOUNCE_MS = 400;

// Dev-only opt-in to short-circuit network with bundled JSON fixtures —
// used for offline / preview / screenshot work. **Must stay false on
// release branches.** Hooks (useRoutingData, useCrateData, useRouteCatalog)
// check this and serve __fixtures__/*.json instead of hitting the API.
// The is_cmo_cp permission gate is NOT bypassed in fixtures mode — even
// with the flag on, only CP leaders see the tiles and the inner screens.
export const USE_FIXTURES = false;
